import { Element, Transforms } from 'slate'
import { EditorService } from '../EditorService'

export const SpreadsheetCommands = {
  getColumnId(col: number) {
    let ret: string, a: number, b: number
    for (ret = '', a = 1, b = 26; (col -= a) >= 0; a = b, b *= 26) {
      ret = String.fromCharCode(parseInt(`${(col % b) / a}`) + 65) + ret
    }
    return ret
  },

  addSpreadsheet(s: EditorService) {
    const spreadsheet = { type: 'spreadsheet', children: [{ text: '' }] }
    Transforms.insertNodes(s.editor, spreadsheet)
  },
}

export interface ISpreadsheetElement extends Element {
  type: 'spreadsheet'
  // children: IDashboardWidgetElement[]
}
